import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "space-y-1" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = ["id", "name", "placeholder", "value"]
const _hoisted_5 = {
  key: 1,
  class: "text-red-400 text-xs mt-1 ml-1"
}
const _hoisted_6 = {
  key: 2,
  class: "text-xs text-gray-400 mt-1 ml-1"
}

import { computed } from 'vue';

interface Props {
  id: string;
  name: string;
  label?: string;
  modelValue?: string;
  placeholder?: string;
  error?: string;
  helpText?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PhoneInput',
  props: {
    id: {},
    name: {},
    label: { default: '' },
    modelValue: { default: '' },
    placeholder: { default: 'Broj telefona (OPCIONO)' },
    error: { default: '' },
    helpText: { default: 'Format: 06XXXXXXX (8-10 cifara)' }
  },
  emits: ["update:modelValue", "blur"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const hasError = computed((): boolean => {
  return Boolean(props.error);
});

const localValue = computed((): string => {
  // Show the local format (06XXXXXXX) even if stored in international format
  if (props.modelValue.startsWith('+3816')) {
    return '0' + props.modelValue.substring(4); // +3816XXXXXXX -> 06XXXXXXX
  }
  return props.modelValue;
});

const handleKeydown = (event: KeyboardEvent): void => {
  // Dozvoliti specijalne tastere (backspace, delete, tab, escape, enter, home, end, strelice)
  const allowedKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'Home',
    'End',
    'ArrowLeft',
    'ArrowUp',
    'ArrowRight',
    'ArrowDown',
  ];

  // Dozvoliti Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
  if (event.ctrlKey || event.metaKey) {
    const allowedCtrlKeys = ['a', 'c', 'v', 'x'];
    if (allowedCtrlKeys.includes(event.key.toLowerCase())) {
      return;
    }
  }

  // Ako je key u dozvoljena lista, ne blokiraj
  if (allowedKeys.includes(event.key)) {
    return;
  }

  // Dozvoliti samo brojevi (0-9)
  if (!/^[0-9]$/.test(event.key)) {
    event.preventDefault();
  }
};

const handlePaste = (event: ClipboardEvent): void => {
  event.preventDefault();
  const paste = event.clipboardData?.getData('text') || '';

  // Uzmi samo brojevi iz paste-ovanog teksta
  const numbersOnly = paste.replace(/\D/g, '');

  if (numbersOnly) {
    const target = event.target as HTMLInputElement;
    const currentValue = target.value.replace(/\D/g, '');

    // Kombinuj trenutni i paste-ovani sadržaj, ograničen na 10 cifara
    const newValue = (currentValue + numbersOnly).substring(0, 10);

    // Ažuriraj input value
    target.value = newValue;

    // Emitiraj update
    let internationalValue = newValue;
    if (newValue.startsWith('06')) {
      internationalValue = '+381' + newValue.substring(1);
    }

    emit('update:modelValue', internationalValue);
  }
};

const handleInput = (event: Event): void => {
  const target = event.target as HTMLInputElement;
  let value = target.value;

  // Remove all non-digit characters
  value = value.replace(/\D/g, '');

  // Limit to max 10 digits
  if (value.length > 10) {
    value = value.substring(0, 10);
  }

  // If empty, emit empty string
  if (value === '') {
    emit('update:modelValue', '');
    return;
  }

  // For display, show the local format (06XXXXXXX)
  target.value = value;

  // For the model value, convert to international format when it starts with 06
  let internationalValue = value;
  if (value.startsWith('06')) {
    internationalValue = '+381' + value.substring(1); // 06XXXXXXX -> +3816XXXXXXX
  }

  emit('update:modelValue', internationalValue);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.id,
          class: "block text-sm font-medium text-gray-300"
        }, _toDisplayString(_ctx.label), 9, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        id: _ctx.id,
        name: _ctx.name,
        type: "tel",
        class: _normalizeClass(["block w-full px-3 py-2 border border-gray-600 rounded-md placeholder-gray-400 bg-gray-700 text-white focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm", {
          'border-red-500 focus:ring-red-500 focus:border-red-500': hasError.value,
        }]),
        placeholder: _ctx.placeholder,
        value: localValue.value,
        onInput: handleInput,
        onKeydown: handleKeydown,
        onPaste: handlePaste,
        onBlur: _cache[0] || (_cache[0] = ($event: any) => (emit('blur'))),
        maxlength: "10"
      }, null, 42, _hoisted_4)
    ]),
    (hasError.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.error), 1))
      : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.helpText), 1))
  ]))
}
}

})